import { 
    Avatar, 
    Button, 
    Menu, 
    MenuTrigger, 
    MenuPopover, 
    MenuList, 
    MenuItem, 
    MenuDivider,
    Text,
    Switch,
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogContent,
    DialogActions,
    Link
} from "@fluentui/react-components";
import { 
    SettingsRegular, 
    QuestionCircleRegular, 
    SignOutRegular
} from "@fluentui/react-icons";
import { useMsal } from '@azure/msal-react';

interface HeaderProps {
    setDarkTheme: React.Dispatch<React.SetStateAction<boolean>>
    darkTheme: boolean
}

function Header(props: HeaderProps) {
    const { accounts, instance } = useMsal();
    
    const onThemeChange = (ev: React.ChangeEvent<HTMLInputElement>, data: { checked: boolean }) => {
        props.setDarkTheme(data.checked);
    };

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            padding: '0 20px', 
            height: '48px', 
            borderBottom: '1px solid #edebe9',
            backgroundColor: '#0078d4',
            color: 'white'
        }}>
            <Text weight="semibold" size={500}>e-Invoicing Dashboard</Text>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {/* Settings */}
                <Menu>
                    <MenuTrigger disableButtonEnhancement>
                        <Button appearance="subtle" icon={<SettingsRegular />} aria-label="Settings" style={{ color: 'white' }} />
                    </MenuTrigger>
                    <MenuPopover>
                        <MenuList>
                            <MenuItem>
                                <Switch 
                                    checked={props.darkTheme}
                                    onChange={onThemeChange}
                                    label={props.darkTheme ? "Dark Mode" : "Light Mode"}
                                />
                            </MenuItem>
                        </MenuList>
                    </MenuPopover>
                </Menu>

                {/* Help */}
                <Dialog>
                    <DialogTrigger disableButtonEnhancement>
                        <Button appearance="subtle" icon={<QuestionCircleRegular />} aria-label="Help" style={{ color: 'white' }} />
                    </DialogTrigger>
                    <DialogSurface>
                        <DialogBody>
                            <DialogTitle>Help</DialogTitle>
                            <DialogContent>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    <Text>Contact <Link href="mailto: ctbdevs@microsoft.com">support</Link> for further assistance</Text>
                                    <Link href="https://go.microsoft.com/fwlink/?LinkId=518021" target="_blank" rel="noreferrer">Privacy & Cookies</Link>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <DialogTrigger disableButtonEnhancement>
                                    <Button appearance="secondary">Close</Button>
                                </DialogTrigger>
                            </DialogActions>
                        </DialogBody>
                    </DialogSurface>
                </Dialog>

                {/* Profile */}
                <Menu>
                    <MenuTrigger disableButtonEnhancement>
                        <Button appearance="transparent" icon={<Avatar name={accounts[0]?.name} size={28} />} aria-label="User profile" style={{ color: 'white' }} />
                    </MenuTrigger>
                    <MenuPopover>
                        <MenuList>
                            <MenuItem>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Text weight="semibold">{accounts[0]?.name}</Text>
                                    <Text size={200}>{accounts[0]?.username}</Text>
                                </div>
                            </MenuItem>
                            <MenuDivider />
                            <MenuItem icon={<SignOutRegular />} onClick={() => instance.logoutRedirect()}>
                                Sign out
                            </MenuItem>
                        </MenuList>
                    </MenuPopover>
                </Menu>
            </div>
        </div>
    );
}
export default Header;